// Gatsby requirements
import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'
import Button from 'utils/linkLogic'
import StarRating from './starRating'

// Styles
import * as CSS from './sectionReviews.module.scss'

const SectionReviews = ({ blok, en }) => {

    let totalRatings1 = 0;
    let totalRatings2 = 0;
    let totalRatings3 = 0;
    let totalRatings4 = 0;
    let totalRatings5 = 0;
    let totalRatings6 = 0;

    const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];

    const [openMore, setOpenMore] = useState(3)

    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            {...storyblokEditable(blok)}
        >

            <div className={`wrapper ${CSS.container}`}>

                <div>
                    {blok.topText &&
                        <div className={CSS.topText}>
                            <h2>{blok?.reviews.length} {blok.topText}</h2>
                        </div>
                    }

                    {blok?.reviews?.map((loop, i) => {
                        const date = new Date(loop?.date)
                        return(
                            <div className={CSS.review} key={i} style={{display: i < openMore ? 'block' : 'none'}}>
                                <div className={CSS.nameAndDate}>
                                    <p><span aria-hidden="true">{loop?.name[0]} </span>{loop?.name}</p>
                                    <span>{date.getDate()} {months[date.getMonth()]} {date.getFullYear()}</span>
                                </div>
                                <p>{loop?.review}</p>
                                <ul>
                                    {loop.starRatings.map((innerLoop, i) => {
                                        if (i === 0) { totalRatings1 = totalRatings1 + Number(innerLoop.ratingNumber) }
                                        if (i === 1) { totalRatings2 = totalRatings2 + Number(innerLoop.ratingNumber) }
                                        if (i === 2) { totalRatings3 = totalRatings3 + Number(innerLoop.ratingNumber) }
                                        if (i === 3) { totalRatings4 = totalRatings4 + Number(innerLoop.ratingNumber) }
                                        if (i === 4) { totalRatings5 = totalRatings5 + Number(innerLoop.ratingNumber) }
                                        if (i === 5) { totalRatings6 = totalRatings6 + Number(innerLoop.ratingNumber) }
                                        return (
                                            <li className={CSS.ratingValue} key={i}><span>{innerLoop.text}</span> <StarRating rating={innerLoop.ratingNumber}/></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        )
                    })}

                    <div className={CSS.showMoreButtons}>
                        {/* Show less */}
                        {openMore > 3 && blok?.reviews.length &&
                            <button className="button" onClick={() => setOpenMore(openMore - 3)}>
                                {en === true ? 'Show less' : 'Minder tonen'}
                            </button>
                        }

                        {/* Show more */}
                        {openMore < blok?.reviews.length && blok?.reviews.length > 3 &&
                            <button className="button" onClick={() => setOpenMore(openMore + 3)}>
                                {en === true ? 'Show more' : 'Meer tonen'}
                            </button>
                        }
                    </div>
                </div>

                
                <div>
                    <div className={CSS.totalReview}>
                        <div className={CSS.nameAndRating}>
                            <div className={CSS.name}>
                                <img src={blok?.logo?.filename + '/m/250x0/filters:quality(90)'} alt={blok?.logo?.alt} loading="lazy" />
                                <h2>{blok?.name}</h2>
                            </div>
                            <p className={CSS.totalRating}>{((totalRatings1 + totalRatings2 + totalRatings3 + totalRatings4 + totalRatings5 + totalRatings6) / blok?.reviews[0]?.starRatings.length / blok?.reviews.length).toFixed(1)}</p>
                        </div>
                        <div className={CSS.ratingsAndButtons}>
                            <ul className={CSS.totalReviewRatings}>
                                {blok?.reviews[0]?.starRatings.map((loop, i) => {
                                    return (
                                        <li className={CSS.ratingValue} key={i}><span>{loop.text}</span> {i === 0 ? <StarRating rating={(totalRatings1 / blok?.reviews.length).toFixed(2).toString()}/> : i === 1 ? <StarRating rating={(totalRatings2 / blok?.reviews.length).toFixed(2).toString()}/> : i === 2 ? <StarRating rating={(totalRatings3 / blok?.reviews.length).toFixed(2).toString()}/> : i === 3 ? <StarRating rating={(totalRatings4 / blok?.reviews.length).toFixed(2).toString()}/> : i === 4 ? <StarRating rating={(totalRatings5 / blok?.reviews.length).toFixed(2).toString()}/> : i === 5 ? <StarRating rating={(totalRatings6 / blok?.reviews.length).toFixed(2).toString()}/> : ''}</li>
                                    )
                                })}
                            </ul>
                            {blok?.buttons.length > 0 &&
                                <div className={CSS.buttons}>
                                    {blok.buttons?.map(loop => (
                                        <Button data={loop} />
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                    {blok?.checkmarkList &&
                        <div className={`${CSS.checkmarkList} checkmark`}>
                            <RichTextRenderer data={blok.checkmarkList} />
                        </div>
                    }
                </div>

            </div>

        </section>
    )
}

export default SectionReviews